<!--
 * $Description: 普通列表，依赖vuedraggable,
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年06月02日 15:07:30 +0800
 * @最后修改时间: 2022-06-08 18:30:25
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Tabler.vue
-->
<template>
  <div>
    <!-- 筛选 -->
    <v-container
      v-show="filterable && filterOuter"
      fluid
      class="px-0 mrc-grey"
      :style="{
        '-webkit-transition': 'all 0.3s linear',
        transition: 'all 0.3s linear',
        overflow: 'hidden',
        '-moz-transition': 'all 0.3s linear',
        '-o-transition': 'all 0.3s linear',
        maxHeight: filterable && filterOuter ? '208px' : '0px',
      }"
    >
      <slot name="top-selection" :filter="onFilter"> </slot>
    </v-container>
    <!-- 筛选 -->
    <v-sheet
      :class="
        contentClass +
        (border ? ' mrc-border-solid' : ' ') +
        (rounded ? ' rounded-lg' : ' ')
      "
    >
      <v-data-iterator
        :items="items"
        v-if="listMode == 'item'"
        :items-per-page.sync="itemsPerPage"
        hide-default-footer
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.uuid"
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card hover elevation="5">
                <v-card-text>
                  <v-sheet
                    class="transparent d-flex flex-row"
                    v-for="it in showHeaders"
                    :key="`item-child--${it.uuid}`"
                  >
                    <v-sheet>{{ it.text }}</v-sheet>
                    <v-spacer></v-spacer>
                    <slot :name="'item.' + it.value" :item="item"></slot>
                  </v-sheet>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
      <v-data-table
        v-else
        ref="dataTable"
        id="dataTable"
        :headers="showHeaders"
        v-model="selected"
        :page.sync="page"
        :value="defaultSelect"
        :item-key="itemKey"
        :headers-length="showHeaders.length"
        :loading="Loading"
        :height="height"
        loading-text=""
        :sort-by.sync="sortBySync"
        :sort-desc.sync="sortDescSync"
        fixed-header
        :mobile-breakpoint="499"
        :dense="defaultDense ? defaultDense : dense"
        disable-sort
        multi-sort
        :locale="defaultLang"
        item-class=" fhgf "
        class="mt-2"
        :selectable-key="selectKey"
        hide-default-footer
        :show-select="items_copy.length <= 0 ? false : showSelect"
        :items="items_copy"
        :items-per-page="itemsPerPage"
        @page-count="$tableSetting.pageCount = $event"
        :elevation="0"
        :footer-props="{
          'items-per-page-options': [10, 20, 50],
          'items-per-page-text': $t(
            'label_essweb_list_components_pagenations_perpageLabel'
          ),
        }"
      >
        <!-- [10, 20, 50, 100, -1] 去掉100和全部 2021-11-26 brain -->
        <template
          v-slot:item="{ item, headers, index }"
          v-if="listMode == 'item'"
        >
          <!-- item模式 -->
          <tr :class="' mrc-delay ' + '_' + index + 's'">
            <td
              class="red--text"
              v-for="(it, ind) in headers"
              :key="`it--${ind}`"
              :class="
                it.align == 'center'
                  ? ' text-center'
                  : it.align == 'end'
                  ? 'text-right'
                  : 'text-left'
              "
            >
              <div
                :key="`value---${it.value}`"
                :class="it.class ? it.class : ''"
                class="text--primary"
              >
                <slot :name="'item.' + it.value" :item="item" />
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:top>
          <!-- v-show="filterable && filterInner" -->
          <v-container
            fluid
            ref="selection"
            class="pa-0"
            :style="{
              '-webkit-transition': 'all 0.3s linear',
              transition: 'all 0.3s linear',
              overflow: 'hidden',
              '-moz-transition': 'all 0.3s linear',
              '-o-transition': 'all 0.3s linear',
              maxHeight: filterable && filterInner ? '208px' : '0px',
            }"
          >
            <slot name="top-selection" :filter="onFilter"></slot>
          </v-container>
          <slot name="top"> </slot>
          <v-container
            v-if="filterable && !filterInner && !filterOuter && !isLoading"
            fluid
            class="pa-4 py-0 ma-0 d-flex justify-end play"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  depressed
                  @click="$emit('filter')"
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                >
                  <span class="material-icons-round"> search </span>
                </v-btn>
              </template>
              <span>{{
                $t("message_essweb_system_list_filter_filterTip")
              }}</span>
            </v-tooltip>
          </v-container>
        </template>
        <template v-slot:no-data>
          <v-skeleton-loader
            ref="skeleton"
            :loading="isLoading"
            transition="scale-transition"
            :boilerplate="false"
            type="table-tbody"
            class="mx-auto"
          >
            <noContent
              :reloadBtn="reloadBtn"
              @reload="$emit('reload')"
              :height="Number(height) - 70"
            />
          </v-skeleton-loader>
        </template>
        <template v-slot:no-results>
          <noContent
            v-if="showNoContent"
            :reloadBtn="reloadBtn"
            @reload="$emit('reload')"
          />
        </template>
        <template v-slot:header.data-table-select="{ on, props }">
          <slot name="header.data-table-select" :on="on" :props="props">
            <v-simple-checkbox
              color="primary"
              :ripple="false"
              v-bind="props"
              v-on="on"
            ></v-simple-checkbox>
          </slot>
        </template>
        <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <slot
            name="item.data-table-select"
            :item="item"
            :isSelected="isSelected"
            :select="select"
          >
            <v-simple-checkbox
              color="primary"
              :ripple="false"
              :value="isSelected"
              @input="select($event)"
            ></v-simple-checkbox>
          </slot>
        </template>
        <template
          v-for="it in headers"
          :slot="'item.' + it.value"
          slot-scope="{ item }"
        >
          <div
            :key="`value---${it.value}`"
            class="text--primary d-flex text-body-2"
            :class="
              it.class
                ? it.class
                : it.align == 'center'
                ? 'flex-column text-center justify-center align-center'
                : it.align == 'end'
                ? 'flex-row text-right  justify-end align-end'
                : 'text-left flex-column justify-start align-start'
            "
          >
            <slot :name="'item.' + it.value" :item="item">
              {{ item ? item[it.value] : "" }}
            </slot>
          </div>
        </template>
        <template
          v-for="it in headers"
          :slot="'header.' + it.value"
          slot-scope="{ header }"
          v-if="!isLoading || overLoading"
        >
          <slot :name="'header.' + it.value" :header="header">
            <v-hover
              v-slot:default="{ hover }"
              :disabled="!it.sortable || items.length <= 1"
            >
              <v-sheet
                class="
                  text-body-2
                  transparent
                  table-header-color
                  d-flex
                  max-width
                  flex-row
                  align-center
                "
                :key="it.value"
                height="40"
                :class="
                  it.align == 'center'
                    ? ' text-center justify-center align-center'
                    : it.align == 'end'
                    ? 'text-right justify-end align-end'
                    : 'text-left justify-start align-start'
                "
                :style="{
                  minWidth: needScrollX
                    ? it.width
                      ? it.width + 'px  !important'
                      : '100px !important'
                    : 'none',
                }"
              >
                {{ cannotDrag.indexOf(it.value) == -1 ? it.text : "" }}
                <v-sheet
                  v-if="it.sortable && hover"
                  :style="{ cursor: hover ? 'pointer' : '' }"
                  class="
                    fill-height
                    px-1
                    transparent
                    d-flex
                    flex-column
                    justify-center
                  "
                >
                  <v-hover v-slot:default="{ hover }">
                    <v-sheet
                      width="15"
                      height="15"
                      class="transparent"
                      :color="hover ? 'text--primary' : 'text--secondary'"
                      @click="onSort(header, it.value, 1)"
                    >
                      <i
                        class="material-icons-round table-header-color"
                        :class="hover ? 'md-20' : 'md-18'"
                        style="width: 15px; height: 15px"
                        >arrow_drop_up</i
                      >
                    </v-sheet>
                  </v-hover>
                  <v-hover v-slot:default="{ hover }">
                    <v-sheet
                      width="15"
                      height="15"
                      class="transparent"
                      :color="hover ? 'text--primary' : 'text--secondary'"
                      @click="onSort(header, it.value, 0)"
                    >
                      <i
                        class="material-icons-round table-header-color"
                        :class="hover ? 'md-20' : 'md-18'"
                        style="width: 15px; height: 15px"
                        >arrow_drop_down</i
                      >
                    </v-sheet>
                  </v-hover>
                </v-sheet>
              </v-sheet>
            </v-hover>
          </slot>
        </template>
        <template
          v-slot:header.action="{ headers }"
          v-if="(!closeAction && !isLoading) || overLoading"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="show = true">
                <span class="material-icons-round">settings</span>
              </v-btn>
            </template>
            <span>{{
              $t("message_essweb_list_components_config_toolTip2")
            }}</span>
          </v-tooltip>
        </template>
        <template v-slot:footer="{ props }" v-if="showFooter">
          <slot name="footer">
            <Pagenations
              v-if="items_copy.length"
              :showSelect="showSelect"
              :options="props"
              :pagetype="type"
              :filterpage="page"
              :local-loading="Loading"
              :filterItemsPerPage="itemsPerPage"
              @change="onChange"
              :items="totalCount !== undefined ? totalCount : items_copy"
            />
          </slot>
        </template>
      </v-data-table>
      <!-- selection -->
      <slot name="selection" />
      <!-- tools -->
      <template>
        <!-- 2020-02-03 bug 1438 mel改为相同标题 -->
        <!-- label_essweb_list_components_config_title -->
        <normalDialog
          noAction
          :dialog="show"
          :title="$t('label_essweb_list_components_config_Title2')"
          :persistent="false"
          @close="show = false"
        >
          <template slot="content">
            <v-container class="pa-0 ma-0" fluid>
              <v-sheet class="text--primary text-caption">{{
                $t("label_essweb_list_components_config_dialog_rowHeightLabel")
              }}</v-sheet>
              <v-radio-group v-model="dense" row>
                <v-radio
                  :label="
                    $t('label_essweb_list_components_config_dialog_normalLabel')
                  "
                  :value="false"
                ></v-radio>
                <v-radio
                  :label="
                    $t('label_essweb_list_components_config_dialog_narrowLabel')
                  "
                  :value="true"
                ></v-radio>
              </v-radio-group>
            </v-container>
            <v-container class="pa-0 ma-0" fluid>
              <v-sheet class="py-1 text--primary text-caption">{{
                $t(
                  "label_essweb_list_components_config_dialog_configTitleLabel"
                )
              }}</v-sheet>
              <draggable
                v-model="dragArr"
                draggable=".drag"
                v-bind="{ animation: 500 }"
                :list="curHeaders"
              >
                <v-sheet
                  class="d-flex flex-grow-1 pa-0 align-center"
                  :class="canDrag(item.value) ? 'drag' : ''"
                  v-for="item in curHeaders"
                  :key="item.value"
                >
                  <v-hover
                    v-slot:default="{ hover }"
                    open-delay="100"
                    :style="{
                      cursor: canDrag(item.value) ? 'grab' : 'not-allowed',
                    }"
                    class="mt-3"
                  >
                    <v-card
                      class="
                        white
                        d-flex
                        flex-row
                        justify-start
                        flex-grow-1
                        py-3
                        pr-3
                        pl-0
                        align-center
                      "
                      :elevation="hover && canDrag(item.value) ? 3 : 0"
                      :color="canDrag(item.value) ? 'white' : 'grey lighten-3'"
                    >
                      <!-- 2021-02-03 bug1438 mel -->
                      <!-- <svg-icon
                    size="36"
                    fill="rgba(0,0,0,0.38)"
                    iconClass="dragvertical"
                  /> -->
                      <span
                        class="material-icons-round"
                        :style="{
                          color: canDrag(item.value)
                            ? 'rgba(0, 0, 0, 0.54)'
                            : 'rgba(0, 0, 0, 0.38)',
                        }"
                      >
                        drag_indicator
                      </span>
                      <v-checkbox
                        color="primary"
                        class="mt-0 pt-0 text-body-2 ml-2"
                        @change="onSelect"
                        :disabled="!canDrag(item.value)"
                        v-model="item.mrcSelected"
                        :label="canDrag(item.value) ? item.text : item.text"
                        hide-details
                      ></v-checkbox>
                    </v-card>
                  </v-hover>
                </v-sheet>
              </draggable>
            </v-container>
          </template>
        </normalDialog>
        <!-- <v-dialog v-model="show" width="50%" scrollable max-width="500">
        <v-card>
          <v-card-title class="primary pa-1">
            Configuration
            <v-spacer></v-spacer>
            <v-btn icon class @click.stop="show = false">
              <span class="material-icons-round">
highlight_off
</span>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <draggable
              v-model="dragArr"
              draggable=".drag"
              v-bind="{ animation: 1000 }"
              :list="curHeaders"
            >
              <v-sheet
                class="d-flex flex-grow-1 pa-0 align-center"
                :class="canDrag(item.value) ? 'drag' : ''"
                v-for="item in curHeaders"
                :key="item.value"
              >
                <v-hover
                  v-slot:default="{ hover }"
                  open-delay="100"
                  :style="{
                    cursor: canDrag(item.value) ? 'grab' : 'not-allowed',
                  }"
                  class="mt-2"
                >
                  <v-card
                    class="white d-flex flex-row justify-start flex-grow-1 pt-1 pb-1 pr-3 pl-0 align-center"
                    :elevation="hover && canDrag(item.value) ? 4 : 0"
                    :color="canDrag(item.value) ? 'white' : 'grey lighten-3'"
                  >
                    <svg-icon size="36" fill="grey" iconClass="dragvertical" />
                    <v-checkbox
                      color="primary"
                      class="mt-0 pt-0"
                      @change="onSelect"
                      :disabled="!canDrag(item.value)"
                      v-model="item.mrcSelected"
                      :label="canDrag(item.value) ? item.text : item.value"
                      hide-details
                    ></v-checkbox>
                  </v-card>
                </v-hover>
              </v-sheet>
            </draggable>
          </v-card-text>
        </v-card>
      </v-dialog>-->
      </template>
    </v-sheet>
  </div>
</template>
<script>
import draggable from "vuedraggable";
import { mapGetters } from "vuex";
export default {
  name: "Tabler",
  components: { draggable },
  props: {
    height: { default: undefined, type: [String, Number] },
    defaultSelect: {
      default: () => {
        return [];
      },
      type: Array,
    },
    listType: { default: "", type: String }, //管理端和业务端区分请求headers配置接口
    configHeadKey: { default: "", type: String }, //初始化headers配置
    defaultDense: { default: false, type: Boolean }, //默認緊湊模式
    filterOuter: { default: false, type: Boolean }, //只开启外部筛选
    filterInner: { default: false, type: Boolean }, //只开启内部筛选
    filterable: { default: false, type: Boolean }, //开启筛选, 一般不用
    showNoContent: { default: true, type: Boolean }, //是否显示空内容
    needScrollX: { default: true, type: Boolean }, //是否限宽，横向滚动
    type: { default: "", type: [Number, String] },
    avPerPage: { default: 0, type: [Number, String] },
    headers: { default: [], type: [Array] },
    itemKey: { default: "mrc-key", type: String },
    contentClass: { default: "pa-4 pb-0", type: String },
    totalCount: { default: undefined, type: [String, Number] },
    selectKey: { default: "isSelectable", type: String },
    showSelect: { default: false, type: Boolean },
    closeAction: { default: false, type: Boolean },
    listMode: { default: "list", type: String }, //列表展示模式，list，item
    overLoading: { default: true, type: Boolean },
    showFooter: { default: true, type: Boolean },
    border: { default: false, type: Boolean },
    rounded: { default: true, type: Boolean },
    staff_filter: { default: "", type: [String, Number] },
    filterPageData: { default: null, type: Object },
    items: {
      default: [],
      type: Array,
      validator: function (value) {
        if (value === null || value === undefined) {
          return false;
        } else {
          return true;
        }
      },
    },
    sortBy: {
      default: function () {
        return [];
      },
      type: Array,
    },
    sortDesc: {
      default: function () {
        return [false, true];
      },
      type: Array,
    },
    reloadBtn: {
      default: null,
      type: [String, Number, Object],
    },
  },
  activated() {},
  deactivated() {
    //解决保存筛选条件造成的不刷新显示栏问题
    if (this.configHeadKey) {
      this.configHeaderData = null;
      this.configHeaders(this.configHeadKey, this.listType);
    }
  },
  created() {
    if (this.configHeadKey) {
      this.configHeaderData = null;
      this.configHeaders(this.configHeadKey, this.listType);
    }
  },
  computed: {
    ...mapGetters([
      "isLoading",
      "defaultLang",
      "tablerReset",
      "SelectionRefresh",
      "curNavKey",
    ]),
    items_copy() {
      const that = this;
      // 解决后端返回null报错问题
      if (!this.items) return [];
      else {
        //解决后端uuid重复问题
        this.items.map((item, index) => {
          //公共假期排除
          if (item["map_uuid"] == undefined)
            item["mrc-key"] = item["uuid"]
              ? this.$aesEncrypt(item.uuid + "" + Math.random() * 999999999999)
              : this.$aesEncrypt(Math.random() * 9999999999999 + "");
        });
        return this.items;
      }
    },
    curHeaders() {
      this.headers.forEach((item) => {
        if (!item["text_save"]) item["text_save"] = item.text;
        if (item["text"].indexOf("label_") != -1 && this.defaultLang)
          item["text"] = this.$t(item.text);

        if (item["hidden"] !== undefined) {
          item["hidden"] = item["hidden"];
        } else {
          item["hidden"] = false;
        }

        if (this.cannotConfig.indexOf(item.value) != -1) {
          //缺省字段，不受控制 eg.action
          item["mrcSelected"] = true;
        } else {
          if (this.configHeaderData) {
            //服务端控制
            if (this.configHeaderData[item.value] !== undefined) {
              item["mrcSelected"] = this.configHeaderData[item.value];
            } else {
              item["mrcSelected"] = true;
            }
          } else {
            //本地控制
            if (item["mrcSelected"] !== undefined) {
              item["mrcSelected"] = item["mrcSelected"];
            } else {
              item["mrcSelected"] = true;
            }
          }
        }
      });
      return this.headers;
    },
    showHeaders() {
      if (this.refresh) {
        return this.curHeaders.filter(
          (ele) => !ele.hidden && ele.mrcSelected === true
        );
      }
    },
  },
  watch: {
    filterPageData(val) {
      if (!val) {
        this.onFilter();
      } else {
        this.onFilter(val.page, val.pagesize, val.data);
      }
    },
    curNavKey(val) {
      this.filterData = null;
    },
    tablerReset() {
      this.page = 1;
      this.itemsPerPage = this.avPerPage
        ? this.avPerPage
        : this.$tableSetting.perPageSize;
    },
    defaultLang(val) {
      this.headers.forEach((item) => {
        if (item["text_save"]) item["text"] = this.$t(item.text_save);
      });
    },
    selected(val) {
      this.$emit("select", val);
    },
    defaultSelect(val) {
      this.selected = val;
    },
    sortBy(val) {
      this.sortBySync = val;
    },
    sortDesc(val) {
      this.sortDescSync = val;
    },
    scroll(val) {
      const that = this;
      if (val == 0) {
        this.$Sleep(500).then(() => {
          that.scrollFunction(that.domObj, "dataTable");
        });
      }
    },
    isLoading(val) {
      // if (this.filterable) this.Loading = val;
    },
    staff_filter(val) {
      const that = this;
      if (!val) return;
      if (val !== null) {
        that.Loading = true;
        this.$emit("staffFilter", (page, perPage) => {
          that.$Sleep(2000).then(() => {
            if (page !== undefined) that.page = page;
            if (perPage !== undefined) that.itemsPerPage = perPage;
            that.Loading = false;
          });
        });
      }
    },
  },
  data() {
    return {
      domObj: null,
      page: 1,
      show: false,
      dense: false,
      refresh: Math.random() * 10000000,
      isDesc: -1,
      scroll: 0,
      selected: [],
      sortBySync: [],
      sortDescSync: [],
      dragArr: [],
      cannotDrag: ["action"], //2021-12-02 删除了color
      cannotConfig: ["action"], //不能动态配置的列
      itemsPerPage: 0,
      Loading: false,
      filterData: null,
      configHeaderData: null,
    };
  },
  mounted() {
    const that = this;
    this.itemsPerPage = this.avPerPage
      ? this.avPerPage
      : this.$tableSetting.perPageSize;
    // 2021-07-22 brain 禁止鼠标横向滚轮
    // this.scrollFunction(this.domObj, "dataTable");
    // $(window).on("resize", () => {
    //   that.scroll = 0;
    //   that.scrollFunction(that.domObj, "dataTable");
    // });
  },
  methods: {
    configHeaders(key, type) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "mrbase_sys_client_param",
        url: "/other/get-client-param/",
        data: { param_name: key },
        type: type ? type : "admin",
        notAlert: true,
      }).then((res) => {
        that.configHeaderData = res.data;
      });
    },
    scrollFunction(obj, id) {
      // obj = this.$refs[id];
      obj = document.getElementById(id);
      if (obj.attachEvent) {
        obj.attachEvent("onmousewheel", this.mouseScroll(obj));
      } else if (obj.addEventListener) {
        obj.addEventListener("scroll", this.mouseScroll(obj), false);
      }
      obj.onmousewheel = obj.onmousewheel = this.mouseScroll(obj);
    },
    mouseScroll(obj) {
      const that = this;
      return function () {
        let e =
          window.event || document.all
            ? window.event
            : arguments[0]
            ? arguments[0]
            : event;
        let detail, moveForwardStep, moveBackStep;
        let step = 0;
        if (e.wheelDelta) {
          // google 下滑负数： -120
          detail = e.wheelDelta;
          moveForwardStep = -1;
          moveBackStep = 1;
        } else if (e.detail) {
          // firefox 下滑正数：3
          detail = event.detail;
          moveForwardStep = 1;
          moveBackStep = -1;
        }
        step = detail > 0 ? moveForwardStep * 100 : moveBackStep * 100;
        e.preventDefault();
        let left = $(".v-data-table__wrapper").scrollLeft();
        $(".v-data-table__wrapper").scrollLeft(
          $(".v-data-table__wrapper").scrollLeft() + step
        );
        if ($(".v-data-table__wrapper").scrollLeft() == left && left > 0) {
          that.scroll++;
        }
        if ($(".v-data-table__wrapper").scrollLeft() == 0 && step < 0) {
          that.scroll++;
        }
        if ($(".v-data-table__wrapper").scrollLeft() == 0 && step > 0) {
          obj.onmousewheel = null;
          obj.removeEventListener("scroll", null);
        }

        if (that.scroll == 2) {
          obj.onmousewheel = null;
          that.scroll = 0;
          obj.removeEventListener("scroll", null);
        }
      };
    },
    onFilter(page, perpage, data) {
      const that = this;

      this.Loading = true;
      if (page !== undefined) that.page = page;
      if (perpage !== undefined) that.itemsPerPage = perpage;
      if (data !== undefined) that.filterData = data;
      if (page !== undefined || perpage !== undefined) this.Loading = false;
    },
    onSort(header, prop, desc) {
      const that = this;
      if (this.isDesc === desc) return; //连续点击相同排序
      if (this.items.length <= 1) return; //只有一个，不需要排序
      this.Loading = true;
      this.$Sleep(300).then(() => {
        header.sort(prop, desc, this.onSortCallback);
      });
    },
    onSortCallback: function (desc) {
      const that = this;
      this.$Sleep(500).then(() => {
        that.Loading = false;
        that.isDesc = desc;
      });
    },
    canDrag(value) {
      if (this.cannotDrag.indexOf(value) != -1) {
        return false;
      } else {
        return true;
      }
    },
    onSelect: function (val) {
      this.refresh = Math.random() * 10000000;
    },
    onChange: function (page, perPage) {
      if (this.Loading) return;
      const that = this;
      this.Loading = true;
      if (this.totalCount !== undefined) {
        this.Loading = true;
        this.$emit(
          "change",
          page,
          perPage,
          (page, perPage) => {
            that.$Sleep(2000).then(() => {
              if (page !== undefined) that.page = page;
              if (perPage !== undefined) that.itemsPerPage = perPage;
              that.Loading = false;
            });
          },
          this.filterData
        );
        that.$Sleep(6000).then(() => {
          if (that.Loading) that.Loading = false; //超时
        });
      }

      that.$Sleep(1000).then(() => {
        if (page !== undefined) that.page = page;
        if (perPage !== undefined) that.itemsPerPage = perPage;
        if (this.totalCount === undefined) {
          that.Loading = false;
        }
      });
    },
  },
};
</script>
<style scoped>
.text-body-2 {
  color: rgba(0, 0, 0, 0.38) !important;
}
@keyframes loading {
  0% {
    display: none;
    height: 0px;
  }
  25% {
    height: 10px;
  }
  50% {
    height: 20px;
  }
  75% {
    height: 30px;
  }
  100% {
    display: block;
    height: auto;
  }
}
.play {
  height: 40px;
  overflow: hidden;
  animation-timing-function: ease;
  -webkit-animation-name: loading;
  animation-name: loading;
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
}
</style>
